var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletUnisat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5262_44059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 243,
    height: 300
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.25 0H29V300H271.25V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5262_44059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.873 26.9937L263.297 87.9687C268.696 93.1479 271.353 98.3886 271.269 103.67C271.186 108.95 268.863 113.764 264.322 118.131C259.572 122.701 254.446 125.017 248.963 125.118C243.481 125.2 238.04 122.64 232.641 117.461L167.774 55.1047C160.408 48.0162 153.294 42.9991 146.451 40.0539C139.608 37.1088 132.41 36.6416 124.877 38.6728C117.323 40.6836 109.225 45.863 100.541 54.1906C88.5724 65.7073 82.8596 76.5129 83.4458 86.6079C84.0314 96.7025 89.9742 107.183 101.253 118.01L166.644 180.894C172.105 186.134 174.784 191.374 174.7 196.574C174.616 201.794 172.273 206.608 167.648 211.056C163.045 215.484 157.96 217.799 152.436 217.982C146.911 218.165 141.408 215.626 135.967 210.386L72.5436 149.411C62.2275 139.499 54.7781 130.115 50.1956 121.259C45.613 112.403 43.8971 102.39 45.0898 91.2186C46.157 81.6518 49.3167 72.3898 54.5898 63.4123C59.842 54.4343 67.3751 45.2537 77.1473 35.8495C88.7814 24.6579 99.8926 16.0865 110.481 10.1149C121.048 4.14333 131.28 0.832561 141.157 0.141973C151.054 -0.548616 160.806 1.36066 170.452 5.86979C180.099 10.3789 189.892 17.4067 199.852 26.9937H199.873Z",
    fill: "url(#paint0_linear_5262_44059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.375 273.026L36.9719 212.051C31.5733 206.851 28.9158 201.631 28.9995 196.35C29.0832 191.069 31.4059 186.256 35.9466 181.888C40.6966 177.318 45.8233 175.003 51.3056 174.901C56.788 174.82 62.2285 177.359 67.6272 182.559L132.474 244.915C139.861 252.003 146.954 257.02 153.797 259.966C160.64 262.911 167.838 263.357 175.392 261.347C182.946 259.336 191.043 254.156 199.727 245.808C211.697 234.292 217.409 223.486 216.823 213.392C216.237 203.297 210.295 192.816 199.016 181.97L164.176 148.76C158.714 143.52 156.036 138.279 156.119 133.08C156.203 127.86 158.547 123.046 163.171 118.598C167.775 114.17 172.86 111.855 178.384 111.672C183.908 111.489 189.411 114.028 194.852 119.268L227.704 150.568C238.02 160.48 245.47 169.864 250.053 178.72C254.635 187.576 256.351 197.589 255.158 208.76C254.091 218.327 250.931 227.589 245.658 236.567C240.406 245.544 232.873 254.725 223.101 264.129C211.466 275.321 200.355 283.892 189.767 289.864C179.179 295.836 168.947 299.167 159.049 299.857C149.152 300.548 139.4 298.638 129.754 294.129C120.107 289.62 110.314 282.593 100.354 273.006L100.375 273.026Z",
    fill: "url(#paint1_linear_5262_44059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.924 115.695C152.786 115.695 163.213 105.573 163.213 93.0879C163.213 80.6027 152.786 70.4814 139.924 70.4814C127.061 70.4814 116.634 80.6027 116.634 93.0879C116.634 105.573 127.061 115.695 139.924 115.695Z",
    fill: "url(#paint2_radial_5262_44059)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5262_44059",
    x1: 252.865,
    y1: 62.5179,
    x2: 58.2804,
    y2: 151.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5262_44059",
    x1: 52.8148,
    y1: 240.014,
    x2: 279.454,
    y2: 170.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4FB52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5262_44059",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.924 93.1085) scale(23.2896 22.6066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211C1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletUnisat);
export default __webpack_public_path__ + "static/media/wallet_unisat.c22f030f89f898b490da49eb3475e061.svg";
export { ForwardRef as ReactComponent };